export default "__VITE_ASSET__j$yR87SX__"